import { render, staticRenderFns } from "./Insurers.vue?vue&type=template&id=dfa6f0e6&scoped=true&"
import script from "./Insurers.vue?vue&type=script&lang=js&"
export * from "./Insurers.vue?vue&type=script&lang=js&"
import style0 from "./Insurers.vue?vue&type=style&index=0&id=dfa6f0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa6f0e6",
  null
  
)

export default component.exports